export const selectAllLocation = (state) => state.allLocationData.allLocationData